/* modal */
$(function() {
    var trigger = $('.ModalTrigger');
    var modal = $('.Modal');
    var close = $('.ModalClose');

    trigger.click(function(event) {
        event.preventDefault();
        var modal_id = $(this).data('modal');
        modal.filter('[data-modal="' + modal_id + '"]').addClass('__active');

        $('#filter-channel').val('');
        $('#filter-channel').trigger('change');

        if ($(this).data('url')) {
            $.ajax({
                url: $(this).data('url'),
                beforeSend: function() {
                    $('#modal-content').html('');
                },
                success: function(data) {
                    $('#modal-content').html(data);
                    flatpickr('#modal-content .DatePicker');
                }
            });
        }
    });

    close.click(function() {
        closeModal();
    });

    $('.Modal').click(function(event) {
        if (!$(event.target).closest('.modalblock-content').length) {
            closeModal();
        }
    });

    $(document).keyup(function(e) {
        if (e.keyCode == 27) {
            closeModal();
        }
    });

    function closeModal()
    {
        $('.Modal.__active').removeClass('__active');
        $('#modal-content').html('');
    }
});
